/* eslint-disable camelcase */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-unused-expressions */
import React from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import fetch from 'unfetch'
import { InView } from 'react-intersection-observer'
import { withCookies } from 'react-cookie'

import { AddToWishlist, Alert, Tabs, Tab, ProductCard, QuickView } from '@sainsburys-tech/bolt'
import { isEmpty, formatVariants } from '@sainsburys-tech/boltui-utils'

import Skeleton from './Recommender.skeleton'
import * as Styled from './Recommender.styles'
import { onRecommenderLoaded, onRecommenderInView, onRecommenderChange } from './recommender.tracking'

const productApiOptions = {
  method: 'GET',
  headers: { 'Content-Type': 'application/json', Accept: 'application/vnd.argos-product.v2+json' },
  credentials: 'include'
}

class Recommender extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      recommendations: [],
      activeRecommendation: 0,
      products: [],
      included: [],
      isLoading: true,
      isError: false,
      showQuickView: false,
      selectedProductId: null,
      mvts: null,
      placement: '',
      hasTrackedInitialLoad: false,
      hasTrackedInView: false,
      recommendationIndex: null
    }
  }

  componentDidMount() {
    const { partNumber } = this.props
    this.fetchRecommendations(partNumber)
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps = nextProps => {
    const { partNumber } = nextProps
    const isDifferentPartNumber = partNumber !== this.props.partNumber
    if (isDifferentPartNumber) this.fetchRecommendations(partNumber)
  }

  fetchRecommendations = partNumber => {
    this.setState({ isLoading: true }, () => {
      fetch(
        `/product-api/recommendations-service/partNumber/${partNumber}/type/clothing?returnMeta=true`,
        productApiOptions
      )
        .then(response => response.json())
        .then(response => {
          const recommendations = this.getRecommendationsList(response)
          const mvts = get(response, 'data.data.attributes.mvts', [])
          const placement = get(response, 'data.data.id', '')
          this.setState(
            {
              recommendations,
              mvts,
              placement
            },
            () => !isEmpty(recommendations) && this.fetchProductDetails(recommendations[0])
          )
        })
        .catch(() => {
          this.setState({ isLoading: false, isError: true })
        })
    })
  }

  fetchProductDetails = recommendation => {
    const { hasTrackedInitialLoad } = this.state
    this.setState({ isLoading: true }, () => {
      const partNumbers = recommendation && recommendation.items.map(item => item.id).join(',')
      fetch(`/product-api/pdp-service/partNumber/${partNumbers}?returnMeta=true`, productApiOptions)
        .then(response => response.json())
        .then(products => {
          this.setState(
            {
              isLoading: false,
              isError: false,
              products: products.data,
              included: products.included
            },
            () => this.trackRecommenderLoaded(hasTrackedInitialLoad)
          )
        })
        .catch(() => this.setState({ isLoading: false, isError: true }))
    })
  }

  getRecommendationsList = recommendations =>
    recommendations.data.included.map(rec => ({
      items: this.props.type === 'clothing' ? rec.attributes.items.reverse() : rec.attributes.items
    }))

  getProductList = products => products.map(product => product.id)

  getProductVariants = (type, product, included) => {
    const { variants } = included.find(inc => inc.type === 'variants' && inc.id === product.id).attributes
    const current = variants.find(variant => variant.partNumber === product.id)
    const variantsFormatted = formatVariants(variants, current.partNumber).filter(variant => variant.type === type)

    return (
      !isEmpty(variantsFormatted) &&
      variantsFormatted[0].products.map(prod => ({
        variantLabel: prod.value,
        partNumber: prod.partNumber
      }))
    )
  }

  getProductReviews = (included, product) => {
    const productsWithReviews = included.find(inc => inc.type === 'reviewstatistics' && inc.id === product.id)
    return productsWithReviews?.attributes
  }

  getProductPrice = (included, product) => {
    const productPrice = included.find(inc => inc.type === 'prices' && inc.id === product.id)
    return productPrice?.attributes?.now
  }

  getInnerPlacement = (type, index) => (type === 'clothing' ? `Outfit ${index}` : `Look ${index}`)

  toggleActiveRecommendation = activeRecommendation =>
    this.setState({ activeRecommendation }, () =>
      this.fetchProductDetails(this.state.recommendations[activeRecommendation])
    )

  toggleQuickView = (selectedProductId = null) =>
    this.setState({
      selectedProductId: selectedProductId === null ? this.state.selectedProductId : selectedProductId,
      showQuickView: !this.state.showQuickView
    })

  renderItems = (items, activeRecommendation, type) => {
    const { 'data-test': dataTest, partNumber } = this.props
    if (type === 'default')
      return (
        <img
          src={`//media.4rgos.it/s/Argos/${partNumber}_R_SET?$Thumb${440}$&$Web$`}
          className='xs-12--none'
          loading='lazy'
          alt={`Recommended item: ${partNumber}`}
          data-test={`${dataTest}-item`}
        />
      )
    return items.map((item, index) => (
      <img
        key={item.id + item.score + activeRecommendation}
        className='xs-6--negative'
        src={`//media.4rgos.it/s/Argos/${item.id}_R_SET/2?$Thumb${440}$&$Web$`}
        loading='lazy'
        alt={`Recommended item: ${item.id}`}
        data-test={`${dataTest}-item-${index}`}
      />
    ))
  }

  trackRecommenderLoaded = (hasChanged = false) => {
    const {
      mvts,
      recommendations,
      activeRecommendation,
      placement,
      hasTrackedInitialLoad,
      hasTrackedInView
    } = this.state
    const { heading, type } = this.props
    const displayedList = []
    const fullList = []
    recommendations.forEach(rec => rec.items.forEach(item => fullList.push(item.id)))
    !isEmpty(recommendations) &&
      recommendations[activeRecommendation].items.forEach(item => displayedList.push(item.id))
    const innerPlacement = this.getInnerPlacement(type, activeRecommendation + 1)
    const recommenderOptions = {
      displayedList,
      fullList,
      title: heading,
      placement,
      mvts,
      innerPlacement,
      window
    }
    if (!hasTrackedInitialLoad) {
      const recommendationIndex = onRecommenderLoaded(recommenderOptions)
      this.setState({ hasTrackedInitialLoad: true, recommendationIndex })
    } else if (!hasTrackedInView && hasTrackedInitialLoad) {
      onRecommenderInView(recommenderOptions)
      this.setState({
        hasTrackedInView: true
      })
    } else if (hasChanged) {
      onRecommenderChange(recommenderOptions, this.state.recommendationIndex)
    }
  }

  trackRecommenderInView = () => {
    const { hasTrackedInView, hasTrackedInitialLoad } = this.state
    if (!hasTrackedInView && hasTrackedInitialLoad) {
      this.trackRecommenderLoaded()
    }
  }

  render() {
    const { heading, partNumber, type, className, 'data-test': dataTest } = this.props
    const {
      recommendations,
      activeRecommendation,
      products,
      included,
      placement,
      isLoading,
      isError,
      showQuickView,
      selectedProductId
    } = this.state

    if (!recommendations.length) return null

    const clickOrigin = 'ctlComponent'
    const pageCategory = `PDP[${partNumber}]`
    const sectionPlacement = clickOrigin
    const innerPlacement = this.getInnerPlacement(type, activeRecommendation + 1)
    const sectionTitle = 'CTL'
    const strategy = placement
    const trackingOptions = {
      eventName: 'quickviewLbPage',
      type: 'quickview',
      clickOrigin,
      queryParams: {
        pageCategory,
        sectionPlacement,
        innerPlacement,
        sectionTitle,
        strategy
      }
    }

    return (
      <InView
        as='div'
        onChange={this.trackRecommenderInView}
        threshold={0.5}
        triggerOnce
        className={className}
        data-test={dataTest}
      >
        {heading && (
          <Styled.Heading className='xs-row' data-test={`${dataTest}-heading`}>
            <h2>{heading}</h2>
          </Styled.Heading>
        )}
        {isLoading && <Skeleton />}
        {isError && (
          <Alert kind='error' isCloseable={false}>
            Oops something went wrong...
          </Alert>
        )}
        {!isLoading && !isError && (
          <div className='xs-row'>
            <div className='xs-12--none md-4--none'>
              {recommendations.length > 1 && (
                <Tabs
                  data-test={`${dataTest}-pagination`}
                  activeTabFromProp={activeRecommendation}
                  toggleTabCallback={index => {
                    this.toggleActiveRecommendation(index)
                  }}
                >
                  {recommendations.map((recom, index) => (
                    <Tab
                      key={`outfit-${index + 1}`}
                      isActive={activeRecommendation === index}
                      label={this.getInnerPlacement(type, index + 1)}
                      data-test={`${dataTest}-pagination-tab-${index}`}
                    />
                  ))}
                </Tabs>
              )}
              {this.renderItems(recommendations[activeRecommendation].items, activeRecommendation, type)}
            </div>
            <Styled.Carousel className='xs-12--negative md-8--none'>
              {products.map((product, index) => {
                const colorVariants = type === 'clothing' && this.getProductVariants('Colour', product, included)
                const reviews = this.getProductReviews(included, product)
                const price = this.getProductPrice(included, product)
                const trackingQueryParams = `?rec=${pageCategory}:${sectionPlacement}:${innerPlacement}:${sectionTitle}:${strategy}:${product.id}`
                return (
                  <ProductCard
                    productLink={`/product/${product.id}${trackingQueryParams}`}
                    key={product.id}
                    partNumber={product.id}
                    isImageHoverActive
                    name={product.attributes.name}
                    price={price}
                    freeDelivery={product.attributes.freeDelivery}
                    mto={product.attributes.madeToOrder}
                    className='xs-10 sm-5 md-block md-5 lg-4'
                    hasVariations={product.attributes.hasVariations}
                    colorVariants={colorVariants}
                    displayRating={reviews}
                    rating={reviews ? reviews.avgRating : 0}
                    reviewsCount={reviews ? reviews.reviewCount : 0}
                    cta={
                      <Styled.QuickViewButton
                        kind='secondary'
                        onClick={() => this.toggleQuickView(product.id.toString())}
                        data-test={`${dataTest}-qv-button-${index}`}
                      >
                        More Details
                      </Styled.QuickViewButton>
                    }
                    wishlistCta={
                      <AddToWishlist.Button
                        item={{
                          partNumber: product.id,
                          hasVariant: product.attributes.hasVariations
                        }}
                        tooltipPosition='center'
                        tooltipDirection='up'
                        tooltipDurationToShow={10000}
                        tooltipWidth={260}
                        data-test={`${dataTest}-atw-button`}
                      />
                    }
                    data-test={`${dataTest}-card-${index}`}
                  />
                )
              })}
            </Styled.Carousel>
          </div>
        )}
        {!!products.length && (
          <QuickView
            show={showQuickView}
            toggleQuickView={this.toggleQuickView}
            trackingOptions={trackingOptions}
            selectedProductId={selectedProductId}
            heading='Get The Look'
            data-test={`${dataTest}-quick-view`}
          />
        )}
      </InView>
    )
  }
}

Recommender.propTypes = {
  /**
   * Specify an optional Heading at the top of the component
   */
  heading: PropTypes.string,
  /**
   * Required partnumber of the product you want to get recommendations for.
   */
  partNumber: PropTypes.string,
  /**
   * the type of product card template that you are wanting to show.
   */
  type: PropTypes.oneOf(['default', 'clothing']),
  /**
   * Prop for e2e testing
   */
  'data-test': PropTypes.string
}
Recommender.defaultProps = {
  heading: '',
  partNumber: '',
  type: 'default',
  'data-test': 'component-recommender'
}

export { Recommender }
export default withCookies(Recommender)
